"use strict";
var __importDefault =
  (this && this.__importDefault) ||
  function(mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, "__esModule", { value: true });
const json_schema_faker_1 = require("json-schema-faker");
const flat_1 = __importDefault(require("flat"));
json_schema_faker_1.option({
  useExamplesValue: false,
  alwaysFakeOptionals: false,
  fillProperties: false,
  requiredOnly: true
});
async function generateJsonObjectFromSchema(schema) {
  return json_schema_faker_1.generate(schema);
}
exports.generateJsonObjectFromSchema = generateJsonObjectFromSchema;
async function getKeysOfObjectFromJSONSchema(schema) {
  let obj = await generateJsonObjectFromSchema(schema);
  delete obj.metadata;
  let flattend = flat_1.default.flatten(obj);
  let keys = Object.keys(flattend).map(x =>
    x
      .split(".")
      .filter(x => isNaN(Number(x)))
      .join(".")
  );
  return keys.filter((x, i, a) => a.indexOf(x) === i);
}
exports.getKeysOfObjectFromJSONSchema = getKeysOfObjectFromJSONSchema;
//# sourceMappingURL=schemaFaker.js.map
